import type { AxiosResponse } from 'axios';

import { API } from '@/api';
import { axiosInstance } from '@/utils/fetcher';

import type { ClaimCommentBase, LossAndDamageClaimFile, LossAndDamageClaimItem } from '../../../types';

export interface PreClaimData {
  claimKey: number;
  carrierKey: number;
  branchKey: number;
  claimNumber: string;
  invoiceNo: string;
  claimProNo: string;
  claimTypeKey: number;
  reasonType: string;
  reasonCode: string;
  consigneeKey: number;
  consigneeShortName: string;
  consigneeName: string;
  consigneeAddr1: string;
  consigneeAddr2: string;
  consigneeCity: string;
  consigneeState: string;
  consigneeZip: string;
  consigneeCountry: string;
  originKey: number;
  shipperShortName: string;
  shipperName: string;
  shipperAddr1: string;
  shipperAddr2: string;
  shipperCity: string;
  shipperState: string;
  shipperZip: string;
  shipperCountry: string;
  cargoShipmentWeight: number;
  dateShipped: string; // '2025-07-13T21:04:42+03:00'
  claimNoOfPieces: number;
  currencyCode: string;
  claimStatusCode: string;
  claimComment: ClaimCommentBase[];
  claimItem: LossAndDamageClaimItem[];
  claimFile: LossAndDamageClaimFile[];
}

export const createPreClaimsAPI = (data: PreClaimData) => {
  return axiosInstance.request({
    data,
    method: 'post',
    url: `${API.PRECLAIM}/SaveClaim`,
  });
};

export type CreatePreClaimResponse = number;

export const createPreClaim = async (data: PreClaimData): Promise<CreatePreClaimResponse> => {
  const response: AxiosResponse<CreatePreClaimResponse> = await createPreClaimsAPI(data);
  return response.data;
};
